import React from 'react';
import PropTypes from 'prop-types';
import StyledCheckbox from '../../checkbox';

export function CheckboxControl({ name, value, children, settings, onChange, ...props }) {
  return (
    <StyledCheckbox
      style={{ alignItems: 'center' }}
      checked={value}
      onChange={event =>
        onChange({
          target: { name, value: event.target.checked },
        })
      }
      {...settings}
      {...props}
    >
      {children}
    </StyledCheckbox>
  );
}

CheckboxControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.bool,
  settings: PropTypes.any,
  onChange: PropTypes.func,
  children: PropTypes.node,
};
